import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
import { Moment } from 'moment';

export interface CovidTestData {
  testDate: Date;
  testManufacturer: string;
  testType: string;
  testResult: string;
  testObserver: string;
  files: any[];
  resultAnswerText: string;
  testLocationId: string;
  testLotNumber: string;
  expirationDate: Date;
  amendExpirationDate: Date;
  testRedCntrlLinePresent: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/** @title Datepicker emulating a Year and month picker */
@Component({
  selector: 'app-expiration-date',
  templateUrl: 'expiration-date.component.html',
  styleUrls: ['covid-test.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})



export class DatepickerExpirationSelection {
  expiration = new UntypedFormControl(moment());
  public data: CovidTestData;
  @Output() covidTestExpDate = new EventEmitter<Date>();
  expirationDate: Date;


  ngOnInit() {
    this.data = {} as CovidTestData;
  }


  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.expiration.value;
    ctrlValue.year(normalizedYear.year());
    this.expiration.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.expiration.value;
    ctrlValue.month(normalizedMonth.month());
    this.expiration.setValue(ctrlValue);
    this.expirationDate = normalizedMonth.toDate();
    datepicker.close();
    this.covidTestExpDate.emit(normalizedMonth.toDate());
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.covidTestExpDate.emit(event.value);
  }
}
